import { DollarSign} from "lucide-react";
import React from "react";
import './styles.css'
import { Money } from "./utils";

interface PlayerBalanceProps {
  user: { id: string;  username: string , balance: Money|undefined} | null;
}

export default function PlayerBalance({ user }: PlayerBalanceProps) {
  
  if (!user) return null;

  let balance = "0.00";
  if(user.balance?.amount){
    balance = parseFloat(user.balance?.amount).toFixed(2);
  }

  return (
    <div className="balance-container">
      <div className="flex items-center space-x-2">
        <DollarSign className="icon-md text-white" />
        <span className="text-white font-semibold">
          Balance: {user.balance !== null ? `$${balance}` : "Loading..."}
        </span>  
      </div>
    </div>
  );
}
